// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
  Headers
 */
/*
  Base Sizing
 */
/*
  Colors
 */
/*
  Border Radii Sizes
 */
/*
  Shadows
 */
/*
  Global Styles
 */
html {
  font-size: 10px;
}

/**
 * COODE Header Colors
 */
.live-pml-table .load-card {
  background-color: white;
  margin: 32px 0;
  border-radius: 4px;
  box-shadow: 0 1px 8px 0 rgba(0, 0, 0, 0.16);
}
.live-pml-table__table {
  width: 100%;
  background-color: white;
  margin: 32px 0;
  border-radius: 4px;
  box-shadow: 0 1px 8px 0 rgba(0, 0, 0, 0.16);
}
.live-pml-table__table__extra-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #f5f5f5;
  padding: 12px 16px;
  min-height: 45px;
}
.live-pml-table__table__extra-header__title .pui-headline {
  font-weight: bold;
  color: #4a4a4a;
  margin: 0;
}
.live-pml-table__table__extra-header__toggle .pui-toggle {
  margin: 0;
}
.live-pml-table__table__extra-header__actions {
  display: flex;
  gap: 10px;
}
.live-pml-table__table__extra-header__actions .pui-button {
  padding: 0;
}
.live-pml-table .card-header button.btn {
  padding-left: 20px;
  cursor: default;
}
.live-pml-table .table-scroll::-webkit-scrollbar {
  display: none;
}
.live-pml-table .table-scroll {
  -ms-overflow-style: none;
}
.live-pml-table .scroll-bottom-bar {
  overflow-x: scroll;
  overflow-y: hidden;
  position: sticky;
  bottom: 0;
  display: flex;
  white-space: nowrap;
}
.live-pml-table .wbs-wrapper {
  min-width: 24rem;
  max-width: 24rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.live-pml-table .country-wrapper {
  min-width: 24rem;
  max-width: 24rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.live-pml-table .plant-wrapper {
  min-width: 16rem;
  max-width: 16rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.live-pml-table .unit-wrapper {
  min-width: 19.2rem;
  max-width: 19.2rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.live-pml-table .project-wrapper {
  min-width: 11.2rem;
  max-width: 11.2rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.live-pml-table .lump-wrapper {
  min-width: 11.2rem;
  max-width: 11.2rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.live-pml-table .aero-wrapper {
  min-width: 16rem;
  max-width: 16rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.live-pml-table .justification-wrapper {
  min-width: 33.6rem;
  max-width: 33.6rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.live-pml-table .maintenance-wrapper {
  min-width: 22.4rem;
  max-width: 22.4rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.live-pml-table .outageid-wrapper {
  min-width: 16rem;
  max-width: 16rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.live-pml-table .risk-wrapper {
  min-width: 18.4rem;
  max-width: 18.4rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.live-pml-table .procurement-wrapper {
  min-width: 27.2rem;
  max-width: 27.2rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.live-pml-table .comment-wrapper {
  min-width: 24rem;
  max-width: 24rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.live-pml-table .planning-wrapper {
  min-width: 30.4rem;
  max-width: 30.4rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.live-pml-table .budget-wrapper {
  min-width: 18.4rem;
  max-width: 18.4rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.live-pml-table .startdate-wrapper {
  min-width: 11.2rem;
  max-width: 11.2rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.live-pml-table .enddate-wrapper {
  min-width: 11.2rem;
  max-width: 11.2rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.live-pml-table .currency-wrapper {
  min-width: 10.4rem;
  max-width: 10.4rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.live-pml-table .spenduntil-wrapper {
  min-width: 19.2rem;
  max-width: 19.2rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.live-pml-table .previous-wrapper {
  min-width: 16rem;
  max-width: 16rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.live-pml-table .previousplusone-wrapper {
  min-width: 16rem;
  max-width: 16rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.live-pml-table .previousplustwo-wrapper {
  min-width: 16rem;
  max-width: 16rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.live-pml-table .previoustotal-wrapper {
  min-width: 16rem;
  max-width: 16rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.live-pml-table .forecast-wrapper {
  min-width: 16.8rem;
  max-width: 16.8rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.live-pml-table .newmtpplus1-wrapper {
  min-width: 13.6rem;
  max-width: 13.6rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.live-pml-table .newmtpplus2-wrapper {
  min-width: 13.6rem;
  max-width: 13.6rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.live-pml-table .newmtpplus3-wrapper {
  min-width: 13.6rem;
  max-width: 13.6rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.live-pml-table .after-wrapper {
  min-width: 10.4rem;
  max-width: 10.4rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.live-pml-table .total-wrapper {
  min-width: 10.4rem;
  max-width: 10.4rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.live-pml-table .cr-wrapper {
  min-width: 10.4rem;
  max-width: 10.4rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.live-pml-table .fundingstatus-wrapper {
  min-width: 17.6rem;
  max-width: 17.6rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.live-pml-table .primary-wrapper {
  min-width: 30.4rem;
  max-width: 30.4rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.live-pml-table .mainflag-wrapper {
  min-width: 24rem;
  max-width: 24rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.live-pml-table .otherflag-wrapper {
  min-width: 24rem;
  max-width: 24rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.live-pml-table .review-wrapper {
  min-width: 30.4rem;
  max-width: 30.4rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.live-pml-table .priocategory-wrapper {
  min-width: 24rem;
  max-width: 20.8rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.live-pml-table .priorank-wrapper {
  min-width: 24rem;
  max-width: 20.8rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.live-pml-table .focustopics-wrapper {
  min-width: 24rem;
  max-width: 20.8rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.live-pml-table .created-wrapper {
  min-width: 11.2rem;
  max-width: 11.2rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.live-pml-table .createdby-wrapper {
  min-width: 17.6rem;
  max-width: 17.6rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.live-pml-table .modified-wrapper {
  min-width: 11.2rem;
  max-width: 11.2rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.live-pml-table .modifiedby-wrapper {
  min-width: 17.6rem;
  max-width: 17.6rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.live-pml-table .outagetype-wrapper {
  min-width: 11.2rem;
  max-width: 11.2rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.live-pml-table .header-table {
  display: flex;
  height: 48px;
  background-color: white;
  border-top: 1px solid #dee2e6;
  border-bottom: 1px solid #dee2e6;
}
.live-pml-table .header-table.fixed-scrool-bottom {
  height: 0;
  border: none;
}
.live-pml-table .header-table .fixed-globalid {
  position: sticky;
  left: 0;
  min-width: 22.464rem;
  max-width: 22.464rem;
  background-color: white;
  border-right: none;
  padding-left: 25px;
}
.live-pml-table .header-table .fixed-globalid .checkmark {
  top: 13px;
}
.live-pml-table .header-table .fixed-name {
  position: sticky;
  left: 22.464rem;
  min-width: 41.6rem;
  max-width: 41.6rem;
  background-color: white;
  border-left: 1px solid #d4d4d4;
  border-right: 1px solid #d4d4d4;
  box-shadow: 2px 0px 3px rgba(0, 0, 0, 0.1);
}
@media (max-width: 991px) {
.live-pml-table .header-table .fixed-globalid {
    position: relative;
    left: 0;
    min-width: 19.2rem;
    max-width: 19.2rem;
    background-color: white;
    border-right: none;
    padding-left: 25px;
}
.live-pml-table .header-table .fixed-globalid .checkmark {
    top: 13px;
}
.live-pml-table .header-table .fixed-name {
    position: relative;
    left: 0;
    min-width: 22.48rem;
    background-color: white;
    border-left: 1px solid #d4d4d4;
    border-right: 1px solid #d4d4d4;
    box-shadow: none;
}
}
@media (max-width: 767px) {
.live-pml-table .header-table .fixed-name {
    min-width: 19.28rem;
}
}
.live-pml-table .header-table div {
  padding: 10px;
  border-right: 1px solid #d4d4d4;
}
.live-pml-table .header-table-wrapper {
  position: sticky;
  top: 90px;
  z-index: 2;
}
.live-pml-table .subtitle-menu {
  width: 100%;
  background-color: #f9f9f9;
  padding: 5px 15px;
  font-size: 17px;
}
.live-pml-table .export {
  text-align: right;
  min-width: 130px;
}
.live-pml-table .export .fa-icon {
  margin-right: 8px;
}
.live-pml-table .mtp-select {
  width: 300px;
}
.live-pml-table .multiselect-menu .fa-icon {
  float: right;
  top: -4px;
  right: -5px;
  position: relative;
}
.live-pml-table .multiselect-menu .section-button .btn {
  padding: 5px 15px;
  margin-top: 0;
  border: none;
  color: #007bff;
  background-color: transparent;
}
.live-pml-table .multiselect-menu .section-button .btn:nth-child(2) {
  position: relative;
  right: 0;
}
.live-pml-table .multiselect-menu .section-button {
  display: flex;
  justify-content: space-between;
  padding: 5px 10px;
  background-color: #F3F5F7;
  border-bottom-left-radius: 0.4rem;
  border-bottom-right-radius: 0.4rem;
}
.live-pml-table .multiselect-menu .dropdown-divider {
  margin: unset;
  margin-top: 8px;
}
.live-pml-table .multiselect-menu .dropdown-menu.show {
  overflow-y: auto;
  max-height: 400px;
}
@media (max-width: 767px) {
.live-pml-table .multiselect-menu .dropdown-menu.show {
    max-height: 280px;
}
}
.live-pml-table .multiselect-menu .sticky-position {
  position: sticky;
  bottom: 0;
}
.live-pml-table .multiselect-menu .style-dropdown-filter {
  box-shadow: 2px 5px 9px 0px rgba(0, 0, 0, 0.2);
  padding-bottom: 0;
}
.live-pml-table .multiselect-menu .active-filter.btn-primary {
  background-color: #0062cc;
  color: white;
}
.live-pml-table .multiselect-menu .btn-filter {
  overflow: hidden;
  text-overflow: ellipsis;
  width: 300px;
  min-height: 38px;
  white-space: nowrap;
  box-shadow: none !important;
  text-align: left;
}
.live-pml-table .multiselect-menu .custom-button {
  width: 100%;
}
.live-pml-table .multiselect-menu {
  /* Hide the browser's default checkbox */
}
.live-pml-table .multiselect-menu .container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}
.live-pml-table .multiselect-menu {
  /* Create a custom checkbox */
}
.live-pml-table .multiselect-menu .checkmark {
  position: absolute;
  margin-left: -15px;
  height: 20px;
  width: 20px;
  border: 2px solid #d0d0d0;
  border-radius: 4px;
  top: unset;
  margin-top: -8px;
}
.live-pml-table .multiselect-menu {
  /* When the checkbox is checked, add a blue background */
}
.live-pml-table .multiselect-menu .container input:checked ~ .checkmark {
  background-color: #2196F3;
  border: 2px solid #2196F3;
}
.live-pml-table .multiselect-menu {
  /* Create the checkmark/indicator (hidden when not checked) */
}
.live-pml-table .multiselect-menu .checkmark:after {
  content: "";
  position: absolute;
  display: none;
}
.live-pml-table .multiselect-menu {
  /* Show the checkmark when checked */
}
.live-pml-table .multiselect-menu .container input:checked ~ .checkmark:after {
  display: block;
}
.live-pml-table .multiselect-menu {
  /* Style the checkmark/indicator */
}
.live-pml-table .multiselect-menu .container .checkmark:after {
  left: 6px;
  top: 0px;
  width: 5px;
  height: 14px;
  border: solid white;
  border-width: 0 3px 3px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}
.live-pml-table .multiselect-menu .btn {
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.4rem;
}
.live-pml-table .multiselect-menu label.container {
  max-width: 0;
}
.live-pml-table .accordion-reporting {
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.2);
  border-radius: 5px;
  margin-bottom: 100px;
}
.live-pml-table .accordion-reporting .dropright:hover > .dropdown-menu {
  display: block;
}
.live-pml-table .accordion-reporting .section-checked ~ .header-table-wrapper {
  position: sticky;
  top: 195px;
  z-index: 2;
}
.live-pml-table .accordion-reporting .table-scroll::-webkit-scrollbar {
  display: none;
}
.live-pml-table .accordion-reporting .table-scroll {
  -ms-overflow-style: none;
}
.live-pml-table .accordion-reporting .header-table-scroll-sync::-webkit-scrollbar {
  display: none;
}
.live-pml-table .accordion-reporting .header-table-scroll-sync {
  -ms-overflow-style: none;
}
.live-pml-table .accordion-reporting .scroll-bottom-bar {
  overflow-x: scroll;
  overflow-y: hidden;
  position: sticky;
  bottom: 0;
  display: flex;
  white-space: nowrap;
}
.live-pml-table .accordion-reporting .local-wrapper {
  min-width: 24rem;
  max-width: 24rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.live-pml-table .accordion-reporting .cr-id-wrapper {
  min-width: 24rem;
  max-width: 24rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.live-pml-table .accordion-reporting .wbs-wrapper {
  min-width: 24rem;
  max-width: 24rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.live-pml-table .accordion-reporting .country-wrapper {
  min-width: 24rem;
  max-width: 24rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.live-pml-table .accordion-reporting .plant-group-wrapper {
  min-width: 16rem;
  max-width: 16rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.live-pml-table .accordion-reporting .plant-wrapper {
  min-width: 16rem;
  max-width: 16rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.live-pml-table .accordion-reporting .unit-wrapper {
  min-width: 25.6rem;
  max-width: 25.6rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.live-pml-table .accordion-reporting .project-wrapper {
  min-width: 11.2rem;
  max-width: 11.2rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.live-pml-table .accordion-reporting .lump-wrapper {
  min-width: 11.2rem;
  max-width: 11.2rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.live-pml-table .accordion-reporting .aero-wrapper {
  min-width: 16rem;
  max-width: 16rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.live-pml-table .accordion-reporting .justification-wrapper {
  min-width: 33.6rem;
  max-width: 33.6rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.live-pml-table .accordion-reporting .maintenance-wrapper {
  min-width: 22.4rem;
  max-width: 22.4rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.live-pml-table .accordion-reporting .outageid-wrapper {
  min-width: 16rem;
  max-width: 16rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.live-pml-table .accordion-reporting .risk-wrapper {
  min-width: 18.4rem;
  max-width: 18.4rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.live-pml-table .accordion-reporting .procurement-wrapper {
  min-width: 27.2rem;
  max-width: 27.2rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.live-pml-table .accordion-reporting .comment-wrapper {
  min-width: 24rem;
  max-width: 24rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.live-pml-table .accordion-reporting .planning-wrapper {
  min-width: 30.4rem;
  max-width: 30.4rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.live-pml-table .accordion-reporting .budget-wrapper {
  min-width: 18.4rem;
  max-width: 18.4rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.live-pml-table .accordion-reporting .startdate-wrapper {
  min-width: 11.2rem;
  max-width: 11.2rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.live-pml-table .accordion-reporting .enddate-wrapper {
  min-width: 11.2rem;
  max-width: 11.2rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.live-pml-table .accordion-reporting .currency-wrapper {
  min-width: 10.4rem;
  max-width: 10.4rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.live-pml-table .accordion-reporting .spenduntil-wrapper {
  min-width: 19.2rem;
  max-width: 19.2rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.live-pml-table .accordion-reporting .previous-wrapper {
  min-width: 16rem;
  max-width: 16rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.live-pml-table .accordion-reporting .previousplusone-wrapper {
  min-width: 16rem;
  max-width: 16rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.live-pml-table .accordion-reporting .previousplustwo-wrapper {
  min-width: 16rem;
  max-width: 16rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.live-pml-table .accordion-reporting .previoustotal-wrapper {
  min-width: 16rem;
  max-width: 16rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.live-pml-table .accordion-reporting .forecast-wrapper {
  min-width: 16.8rem;
  max-width: 16.8rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.live-pml-table .accordion-reporting .forecasteur-wrapper {
  min-width: 22.4rem;
  max-width: 22.4rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.live-pml-table .accordion-reporting .newmtpplus1-wrapper {
  min-width: 13.6rem;
  max-width: 13.6rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.live-pml-table .accordion-reporting .newmtpplus1eur-wrapper {
  min-width: 19.2rem;
  max-width: 19.2rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.live-pml-table .accordion-reporting .newmtpplus2-wrapper {
  min-width: 13.6rem;
  max-width: 13.6rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.live-pml-table .accordion-reporting .newmtpplus2eur-wrapper {
  min-width: 19.2rem;
  max-width: 19.2rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.live-pml-table .accordion-reporting .newmtpplus3-wrapper {
  min-width: 13.6rem;
  max-width: 13.6rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.live-pml-table .accordion-reporting .newmtpplus3eur-wrapper {
  min-width: 19.2rem;
  max-width: 19.2rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.live-pml-table .accordion-reporting .uel-wrapper {
  min-width: 19.2rem;
  max-width: 19.2rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.live-pml-table .accordion-reporting .after-wrapper {
  min-width: 10.4rem;
  max-width: 10.4rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.live-pml-table .accordion-reporting .total-wrapper {
  min-width: 10.4rem;
  max-width: 10.4rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.live-pml-table .accordion-reporting .fundingstatus-wrapper {
  min-width: 17.6rem;
  max-width: 17.6rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.live-pml-table .accordion-reporting .primary-wrapper {
  min-width: 30.4rem;
  max-width: 30.4rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.live-pml-table .accordion-reporting .mainflag-wrapper {
  min-width: 24rem;
  max-width: 24rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.live-pml-table .accordion-reporting .otherflag-wrapper {
  min-width: 24rem;
  max-width: 24rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.live-pml-table .accordion-reporting .review-wrapper {
  min-width: 30.4rem;
  max-width: 30.4rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.live-pml-table .accordion-reporting .priocategory-wrapper {
  min-width: 24rem;
  max-width: 20.8rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.live-pml-table .accordion-reporting .priorank-wrapper {
  min-width: 24rem;
  max-width: 20.8rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.live-pml-table .accordion-reporting .focustopics-wrapper {
  min-width: 24rem;
  max-width: 20.8rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.live-pml-table .accordion-reporting .created-wrapper {
  min-width: 11.2rem;
  max-width: 11.2rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.live-pml-table .accordion-reporting .createdby-wrapper {
  min-width: 17.6rem;
  max-width: 17.6rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.live-pml-table .accordion-reporting .modified-wrapper {
  min-width: 11.2rem;
  max-width: 11.2rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.live-pml-table .accordion-reporting .modifiedby-wrapper {
  min-width: 17.6rem;
  max-width: 17.6rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.live-pml-table .accordion-reporting .outagetype-wrapper {
  min-width: 11.2rem;
  max-width: 11.2rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.live-pml-table .accordion-reporting .header-table {
  display: flex;
  height: 48px;
  background-color: white;
  border-top: 1px solid #dee2e6;
  border-bottom: 1px solid #dee2e6;
}
.live-pml-table .accordion-reporting .header-table.fixed-scrool-bottom {
  height: 0;
  border: none;
}
.live-pml-table .accordion-reporting .header-table .fixed-globalid {
  position: sticky;
  left: 0;
  min-width: 22.544rem;
  max-width: 22.544rem;
  background-color: white;
  border-right: none;
  padding-left: 25px;
}
.live-pml-table .accordion-reporting .header-table .fixed-globalid .checkmark {
  top: 13px;
}
.live-pml-table .accordion-reporting .header-table .fixed-name {
  position: sticky;
  left: 22.544rem;
  min-width: 41.6rem;
  max-width: 41.6rem;
  background-color: white;
  border-left: 1px solid #d4d4d4;
  border-right: 1px solid #d4d4d4;
  box-shadow: 2px 0px 3px rgba(0, 0, 0, 0.1);
}
@media (max-width: 991px) {
.live-pml-table .accordion-reporting .header-table .fixed-globalid {
    position: relative;
    left: 0;
    min-width: 19.2rem;
    max-width: 19.2rem;
    background-color: white;
    border-right: none;
    padding-left: 25px;
}
.live-pml-table .accordion-reporting .header-table .fixed-globalid .checkmark {
    top: 13px;
}
.live-pml-table .accordion-reporting .header-table .fixed-name {
    position: relative;
    left: 0;
    min-width: 22.48rem;
    background-color: white;
    border-left: 1px solid #d4d4d4;
    border-right: 1px solid #d4d4d4;
    box-shadow: none;
}
}
@media (max-width: 767px) {
.live-pml-table .accordion-reporting .header-table .fixed-name {
    min-width: 19.28rem;
}
}
.live-pml-table .accordion-reporting .header-table div {
  padding: 10px;
  border-right: 1px solid #d4d4d4;
}
.live-pml-table .accordion-reporting .header-table-wrapper {
  position: sticky;
  top: 90px;
  z-index: 2;
}
.live-pml-table .accordion-reporting .icon-dropdown {
  position: absolute;
  margin-top: 4px;
}
.live-pml-table .accordion-reporting .box {
  width: 14px;
  height: 14px;
  display: inline-block;
  top: 1px;
  border-radius: 15px;
  margin-right: 10px;
  position: relative;
}
.live-pml-table .accordion-reporting .fix .dropright .dropdown-toggle::after {
  vertical-align: 0;
  margin-left: 10px;
}
.live-pml-table .accordion-reporting table .fix button span {
  padding-left: 25px;
}
.live-pml-table .accordion-reporting .fix .dropdown-item:disabled {
  opacity: 50%;
}
.live-pml-table .accordion-reporting .showingBR {
  display: inline-block;
  padding-left: 10px;
}
.live-pml-table .accordion-reporting table tr > td:nth-child(1) {
  text-align: start;
}
.live-pml-table .accordion-reporting table .dropdown-item button span {
  margin-left: 10px;
}
.live-pml-table .accordion-reporting .multiselect {
  min-width: 150px;
}
.live-pml-table .accordion-reporting .itemsChecked {
  background-color: #bad8f1 !important;
}
.live-pml-table .accordion-reporting .itemsChecked td {
  background-color: #bad8f1 !important;
}
.live-pml-table .accordion-reporting #dropdownMenuLink {
  position: absolute;
}
.live-pml-table .accordion-reporting label.container {
  max-width: 0;
}
.live-pml-table .accordion-reporting {
  /* Hide the browser's default checkbox */
}
.live-pml-table .accordion-reporting #readyForApproval input {
  position: absolute;
  opacity: 0;
  height: 0;
  width: 0;
}
.live-pml-table .accordion-reporting #readyForApproval span {
  margin-top: 10px;
  color: #007bff;
  background-color: transparent;
  border: 1px solid #ADADAD;
  margin-right: 5px;
  display: inline-block;
  font-weight: 400;
  text-align: center;
  vertical-align: middle;
  user-select: none;
  padding: 0.6rem 1.2rem;
  font-size: 1.6rem;
  line-height: 1.5;
  border-radius: 0.4rem;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.live-pml-table .accordion-reporting #readyForApproval label {
  margin-bottom: 0;
  cursor: pointer;
}
.live-pml-table .accordion-reporting #readyForApproval input:checked + span {
  background: #0062cc;
  color: #fff;
}
.live-pml-table .accordion-reporting {
  /* Hide the browser's default checkbox */
}
.live-pml-table .accordion-reporting .container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}
.live-pml-table .accordion-reporting {
  /* Create a custom checkbox */
}
.live-pml-table .accordion-reporting .checkmark {
  position: absolute;
  top: 15px;
  margin-left: -15px;
  height: 20px;
  width: 20px;
  border: 2px solid #d0d0d0;
  border-radius: 4px;
}
.live-pml-table .accordion-reporting {
  /* When the checkbox is checked, add a blue background */
}
.live-pml-table .accordion-reporting .container input:checked ~ .checkmark {
  background-color: #2196F3;
  border: 2px solid #2196F3;
}
.live-pml-table .accordion-reporting {
  /* Create the checkmark/indicator (hidden when not checked) */
}
.live-pml-table .accordion-reporting .checkmark:after {
  content: "";
  position: absolute;
  display: none;
}
.live-pml-table .accordion-reporting {
  /* Show the checkmark when checked */
}
.live-pml-table .accordion-reporting .container input:checked ~ .checkmark:after {
  display: block;
}
.live-pml-table .accordion-reporting {
  /* Style the checkmark/indicator */
}
.live-pml-table .accordion-reporting .container .checkmark:after {
  left: 6px;
  top: 0px;
  width: 5px;
  height: 14px;
  border: solid white;
  border-width: 0 3px 3px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}
.live-pml-table .accordion-reporting .btn {
  background-color: transparent;
}
.live-pml-table .accordion-reporting .fix input {
  margin-right: 10px;
  margin-left: 5px;
}
.live-pml-table .accordion-reporting .fix:nth-child(1) {
  left: 15px;
  position: absolute;
  width: 22.4rem;
  border-right: 0;
  border-left: 1px solid #d4d4d4;
  padding-left: 25px;
}
.live-pml-table .accordion-reporting .collapsing .fix:nth-child(1) {
  left: 0;
}
.live-pml-table .accordion-reporting .fix:nth-child(2) {
  left: 24rem;
  position: absolute;
  width: 41.6rem;
  border-left: 1px solid #d4d4d4;
  padding-right: 2px;
}
.live-pml-table .accordion-reporting .fix:nth-child(2) div {
  overflow: hidden;
  text-overflow: ellipsis;
}
.live-pml-table .accordion-reporting .collapsing .fix:nth-child(2) {
  left: 22.48rem;
}
.live-pml-table .accordion-reporting tr:nth-child(even) td {
  background-color: #f9f9f9;
}
.live-pml-table .accordion-reporting tr:last-child td {
  border-bottom: 1px solid #d4d4d4;
}
.live-pml-table .accordion-reporting table {
  width: 100%;
  margin-left: 64rem;
  overflow-y: visible;
  padding-bottom: 1px;
  display: block;
}
.live-pml-table .accordion-reporting button:focus {
  box-shadow: none;
}
.live-pml-table .accordion-reporting h5 button {
  width: 100%;
  text-align: left;
  font-size: 1.44rem;
}
.live-pml-table .accordion-reporting .table th {
  border-bottom: 1px solid #dee2e6;
}
.live-pml-table .accordion-reporting .table tr:first-child td:first-child {
  border-top: 1px solid transparent;
}
.live-pml-table .accordion-reporting .table tr:first-child td:nth-child(2) {
  border-top: 1px solid transparent;
}
.live-pml-table .accordion-reporting .active {
  color: #0078dc;
}
.live-pml-table .accordion-reporting .number {
  padding: 0 5px;
  font-weight: bold;
  cursor: pointer;
}
.live-pml-table .accordion-reporting .number ~ .third-number {
  padding-left: 0;
  padding-right: 5px;
}
.live-pml-table .accordion-reporting .arrow {
  cursor: pointer;
  position: relative;
  top: -0.5px;
}
.live-pml-table .accordion-reporting .table th,
.live-pml-table .accordion-reporting .table td {
  border-top: none;
  border-right: 1px solid #d4d4d4;
  white-space: nowrap;
  background-color: white;
}
.live-pml-table .accordion-reporting .table td .btn {
  font-weight: bold;
  padding: 0;
  right: 13px;
  top: 8px;
}
@media (max-width: 991px) {
.live-pml-table .accordion-reporting .table td .btn {
    padding-left: 7px;
}
}
.live-pml-table .accordion-reporting .table {
  background-color: #fff;
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.1);
}
.live-pml-table .accordion-reporting .btn-clear {
  color: #007bff;
}
.live-pml-table .accordion-reporting .button-acc {
  background-color: #f3f5f7;
  padding: 37px 15px 18px;
  display: flex;
  flex-wrap: wrap;
}
.live-pml-table .accordion-reporting .button-acc .select {
  min-width: unset;
}
.live-pml-table .accordion-reporting .button-acc button {
  margin-top: 10px;
}
.live-pml-table .accordion-reporting .button-acc input {
  margin-top: 10px;
}
.live-pml-table .accordion-reporting .button-acc svg {
  position: absolute;
  right: 20px;
  margin-top: 12px;
  top: 9px;
  color: #ADADAD;
  transform: rotate(90deg);
  pointer-events: none;
}
.live-pml-table .accordion-reporting .button-acc svg.search-icon {
  pointer-events: all;
  cursor: pointer;
}
.live-pml-table .accordion-reporting .button-acc svg.icon-times {
  pointer-events: all;
  cursor: pointer;
  right: 45px;
  height: 1.2em;
  top: 7px;
}
.live-pml-table .accordion-reporting .button-acc .checkmark {
  top: unset;
  margin-top: -6px;
}
.live-pml-table .accordion-reporting .button-acc .section-button .btn {
  padding: 5px 15px;
  margin-top: 0;
}
.live-pml-table .accordion-reporting .button-acc .section-button .btn:nth-child(2) {
  position: absolute;
  right: 16px;
}
.live-pml-table .accordion-reporting .button-acc .section-button {
  padding: 5px 10px;
  background-color: #F3F5F7;
  border-bottom-left-radius: 0.4rem;
  border-bottom-right-radius: 0.4rem;
}
.live-pml-table .accordion-reporting .button-acc .dropdown-divider {
  margin: unset;
  margin-top: 8px;
}
.live-pml-table .accordion-reporting .button-acc .style-dropdown-filter {
  box-shadow: 2px 5px 9px 0px rgba(0, 0, 0, 0.2);
  padding-bottom: 0;
}
.live-pml-table .accordion-reporting .button-acc .active-filter.btn-primary {
  background-color: #0062cc;
  color: white;
}
.live-pml-table .accordion-reporting .button-acc .btn-filter {
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 160px;
  white-space: nowrap;
}
.live-pml-table .accordion-reporting .button-acc .btn-primary:hover {
  color: #fff;
  background-color: #0069d9;
  border-color: #0062cc;
}
.live-pml-table .accordion-reporting .section-checked {
  background-color: #0078dc;
  height: 105px;
  align-items: center;
  position: sticky;
  top: 90px;
  z-index: 2;
  padding-top: 10px;
  display: flex;
  flex-wrap: wrap;
}
.live-pml-table .accordion-reporting .section-checked .col a {
  margin-left: 25px;
}
@media (max-width: 768px) {
.live-pml-table .accordion-reporting .section-checked .col a {
    margin-left: 6px;
}
}
.live-pml-table .accordion-reporting .section-checked .icon-cancel {
  padding-right: 5px;
  position: relative;
  font-size: 16px;
}
.live-pml-table .accordion-reporting .section-checked .btn {
  color: #007bff;
}
.live-pml-table .accordion-reporting .btn-primary {
  background-color: transparent;
  border: 1px solid #ADADAD;
  box-shadow: none !important;
  color: #007bff;
  margin-right: 5px;
}
.live-pml-table .accordion-reporting .select {
  background-color: #fff;
  border: 1px solid #ADADAD;
  box-shadow: none !important;
  color: #212529;
  padding-right: 65px;
  padding-left: 15px;
}
.live-pml-table .accordion-reporting .select::placeholder {
  color: #ADADAD;
}
.live-pml-table .accordion-reporting .search-input {
  color: #495057;
  font-size: 16px;
  font-weight: 400;
  line-height: 1.5;
  border-radius: 4px;
  padding: 6px 65px 6px 15px;
  border: solid 1px #adadad;
  background-color: #fff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}
.live-pml-table .accordion-reporting .search-input:focus {
  color: #495057;
  background-color: #fff;
  border-color: #80bdff;
  outline: 0;
  box-shadow: 0 0 0 3.2px rgba(0, 123, 255, 0.25) !important;
}
.live-pml-table .accordion-reporting tbody tr:nth-child(even) {
  background-color: #f9f9f9;
}
@media (min-width: 991px) {
.live-pml-table .accordion-reporting tbody tr td:nth-child(2):after {
    content: " ";
    display: block;
    position: absolute;
    top: 0px;
    width: 3px;
    right: 1px;
    height: 48px;
    -moz-box-shadow: 0px 0px 3px #d1d571;
    box-shadow: 5px 0px 3px rgba(0, 0, 0, 0.1);
}
.live-pml-table .accordion-reporting thead tr th:nth-child(2) {
    border-top-right-radius: 6px;
    box-shadow: 2px 0px 4px rgba(0, 0, 0, 0.1);
}
}
.live-pml-table .accordion-reporting .Blue td:first-child {
  box-shadow: inset 12px 0px 0px -5px #607d8b;
}
.live-pml-table .accordion-reporting .Red td:first-child {
  box-shadow: inset 12px 0px 0px -5px #f50057;
}
.live-pml-table .accordion-reporting .Grey td:first-child {
  box-shadow: inset 12px 0 0px -5px #d6d6d6;
}
.live-pml-table .accordion-reporting .card-body {
  padding: 35px 15px;
  padding-bottom: 10px;
  padding-top: 0;
}
.live-pml-table .accordion-reporting .card-body:first-child {
  padding-bottom: 0;
}
.live-pml-table .accordion-reporting .search-form {
  float: right;
}
@media (min-width: 991px) {
.live-pml-table .accordion-reporting .fixed-name {
    border-top-right-radius: 6px;
}
}
@media (max-width: 991px) {
.live-pml-table .accordion-reporting table {
    margin-left: 0 !important;
    font-size: 1.44rem;
    padding-bottom: 0;
}
.live-pml-table .accordion-reporting table.table th {
    border-left: 1px solid #d4d4d4;
    border-right: none;
}
.live-pml-table .accordion-reporting table.table td {
    border-left: 1px solid #d4d4d4;
    border-right: none;
}
.live-pml-table .accordion-reporting table th.fix:nth-child(1) {
    display: table-cell;
    min-width: 19.2rem;
    max-width: 19.2rem;
    position: relative;
    left: 0;
    right: 0;
    padding-right: 23px;
    padding-left: 20px;
    border-bottom: none;
}
.live-pml-table .accordion-reporting table th.fix:nth-child(2) {
    display: table-cell;
    width: 22.4rem;
    position: relative;
    left: 0;
    right: 0;
}
.live-pml-table .accordion-reporting table td.fix:nth-child(1) {
    display: table-cell;
    min-width: 19.2rem;
    max-width: 19.2rem;
    position: relative;
    left: 0;
    right: 0;
    padding-right: 23px;
    padding-left: 20px;
    border-bottom: none;
}
.live-pml-table .accordion-reporting table td.fix:nth-child(2) {
    display: block;
    position: relative;
    left: 0;
    right: 0;
    width: 22.4rem;
    border-bottom: none;
    min-width: 150px;
}
.live-pml-table .accordion-reporting table td.fix:nth-child(2) div {
    width: 100%;
}
}
@media (max-width: 991px) and (max-width: 767px) {
.live-pml-table .accordion-reporting table td.fix:nth-child(2) {
    width: 19.2rem;
}
}
@media (max-width: 991px) {
.live-pml-table .accordion-reporting table.table td .btn {
    right: 10px;
    top: 5px;
}
.live-pml-table .accordion-reporting table tr:last-child td {
    border-bottom: none;
}
.live-pml-table .accordion-reporting .search-form {
    float: none;
}
.live-pml-table .accordion-reporting .search-form .input-group {
    width: 100%;
}
.live-pml-table .accordion-reporting .form-inline.nav-selectors {
    margin: 0 auto;
    width: 100%;
}
.live-pml-table .accordion-reporting .button-acc {
    padding-top: 15px;
}
.live-pml-table .accordion-reporting .button-acc .btn {
    margin-bottom: 5px;
}
}
@media (max-width: 767px) {
.live-pml-table .accordion-reporting .button-acc .btn-filter {
    width: 100%;
    max-width: none;
    font-size: 1.44rem;
}
.live-pml-table .accordion-reporting #readyForApproval label {
    width: 100%;
}
.live-pml-table .accordion-reporting #readyForApproval label span {
    width: 100%;
    font-size: 1.44rem;
}
}
@media (max-width: 575px) {
.live-pml-table .accordion-reporting .dropdown-menu.style-dropdown-filter {
    font-size: 12px;
    max-width: 180px;
}
.live-pml-table .accordion-reporting .dropdown-menu.style-dropdown-filter label {
    overflow: hidden;
    text-overflow: ellipsis;
}
.live-pml-table .accordion-reporting .showingBR {
    display: block;
    padding-left: 0;
}
.live-pml-table .accordion-reporting .dropright .dropdown-menu {
    top: 30px;
    left: 30%;
}
.live-pml-table .accordion-reporting .element-number {
    font-size: 1.28rem;
}
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
